module.exports = __webpack_public_path__ + "img/square-stripe.e03f0787.png";